module.exports = __webpack_public_path__ + "img/alcoholera-orujos.c4e2297c.jpg";